import React, { useState, useEffect, useRef } from 'react';

const DragAndDrop = ({
  items,
  onDrop,
  render = () => <div></div>,
  depth = 0,
  parentId = null,
  isNested = false,
}) => {
  const [localItems, setLocalItems] = useState(items);
  const [draggedItem, setDraggedItem] = useState(null);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [draggedDepth, setDraggedDepth] = useState(null);
  const [draggedParentId, setDraggedParentId] = useState(null);

  const isInitialRender = useRef(true); // 초기 렌더링 여부를 추적

  const handleDragStart = (e, item, index, depth, parentId) => {
    setDraggedItem(item);
    setDraggedIndex(index);
    setDraggedDepth(depth);
    setDraggedParentId(parentId);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, index, depth, parentId) => {
    e.preventDefault();

    if (draggedParentId !== parentId) {
      alert('다른 상위 카테고리로 이동할 수 없습니다.');
      return;
    }

    const updatedItems = [...localItems];
    updatedItems.splice(draggedIndex, 1);
    updatedItems.splice(index, 0, draggedItem);

    setLocalItems(updatedItems);

    onDrop(
      updatedItems,
      draggedItem,
      draggedIndex,
      index,
      draggedDepth,
      draggedParentId,
      parentId
    );

    setDraggedItem(null);
    setDraggedIndex(null);
    setDraggedDepth(null);
    setDraggedParentId(null);
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
    setDraggedIndex(null);
    setDraggedDepth(null);
    setDraggedParentId(null);
  };

  useEffect(() => {
    setLocalItems(items);
  }, [items]);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false; // 초기 렌더링 이후로 변경
      return;
    }

    onDrop(localItems); // 초기 렌더링이 아닌 경우에만 호출
    // eslint-disable-next-line
  }, [localItems]);

  const renderItems = (items, depth, parentId) => (
    <ul>
      {items.map((item, index) => (
        <li
          key={`drag_item_${depth}_${parentId}_${index}`}
          draggable
          onDragStart={(e) => handleDragStart(e, item, index, depth, parentId)}
          onDragOver={handleDragOver}
          onDrop={(e) => handleDrop(e, index, depth, parentId)}
          onDragEnd={handleDragEnd}
        >
          {render(item)}
          {item.children &&
            isNested &&
            renderItems(item.children, depth + 1, item.id)}
        </li>
      ))}
    </ul>
  );

  return renderItems(localItems, depth, parentId);
};

export default DragAndDrop;
